var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column ga-6 border pa-6 rounded-sm" },
    [
      _c(_setup.BlockTitle, { attrs: { title: "Отзывы врачей" } }),
      _vm._v(" "),
      _vm._l(_vm.doctorReviews, function (doctorReview) {
        return _c("div", { key: doctorReview.id, staticClass: "d-flex" }, [
          _c("img", {
            staticClass: "mr-4 rounded-circle d-block",
            attrs: {
              src: _setup.isMobile
                ? doctorReview.avatar_small.url
                : doctorReview.avatar_large.url,
              alt: "/",
              width: "80px",
              height: "80px",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(_setup.AdminButton, {
                attrs: {
                  text: "править",
                  link: _setup.reverseFull({
                    name: "admin:info_review_change",
                    args: [doctorReview.id],
                  }),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-subtitle-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(doctorReview.surname) +
                    " " +
                    _vm._s(doctorReview.firstname) +
                    " " +
                    _vm._s(doctorReview.secondname) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-body-2 mb-4 text-secondary--text" },
                [
                  _vm._v(
                    "\n        " + _vm._s(doctorReview.position) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2" }, [
                _vm._v("\n        " + _vm._s(doctorReview.text) + "\n      "),
              ]),
            ],
            1
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }